import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";

const CrossIcon = ({ onClose }) => (
  <IconButton className="cross" onClick={onClose}>
    {" "}
    <CloseIcon fontSize="small" />
  </IconButton>
);

export default CrossIcon;
